import { render, staticRenderFns } from "./InstanceTableCustomSort.vue?vue&type=template&id=185ac816&scoped=true"
import script from "./InstanceTableCustomSort.vue?vue&type=script&lang=js"
export * from "./InstanceTableCustomSort.vue?vue&type=script&lang=js"
import style0 from "./InstanceTableCustomSort.vue?vue&type=style&index=0&id=185ac816&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185ac816",
  null
  
)

export default component.exports